import { serviceRoles } from "config/access";
import { QUOTES } from "constants/routes";
import { checkAccess } from "helpers/auth";
import Page from "./container/QuotesPage";

export default function getSettingsRoute(userAuth) {
  const { account, rhapsody } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [rhapsody.name]: [rhapsody.roles.concierge],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: QUOTES,
    withSidebar: true,
    withAppBar: true,
    component: Page,
  };
}
